import { APP_PREFIX, FLOW_TYPE, COUNTRY } from '../../framework/App/AppConstants';
import { PAGE_NAME } from './DEConstants';
import ApplyPage from '../pages/Guest/ApplyPage/ApplyPage';
import SepaPage from '../pages/Guest/SepaPage/SepaPage';
import ContractPage from '../pages/Guest/ContractPage/ContractPage';
import ErrorPage from '../pages/ErrorPage/ErrorPage';
import DecisionPage from '../pages/Guest/DecisionPage/DecisionPage';
import RepaymentPage from '../pages/Member/RepaymentPage/RepaymentPage';
import PersonalInfoPage from '../pages/Member/PersonalInfoPage/PersonalInfoPage';
import TermsPage from '../pages/Member/TermsPage/TermsPage';
import CycoPage from '../pages/Guest/CycoPage/CycoPage';
import DeprecatedPage from '../pages/Guest/DeprecatedPage/DeprecatedPage';

const prodRoutes = [

    // Guest Flow
    {
        path: `${APP_PREFIX}/${FLOW_TYPE.HERMES}/${COUNTRY.GERMANY}/${PAGE_NAME.APPLY_PAGE}`,
        component: ApplyPage
    },
    {
        path: `${APP_PREFIX}/${FLOW_TYPE.HERMES}/${COUNTRY.GERMANY}/${PAGE_NAME.SEPA_PAGE}`,
        component: SepaPage
    },
    {
        path: `${APP_PREFIX}/${FLOW_TYPE.HERMES}/${COUNTRY.GERMANY}/${PAGE_NAME.CONTRACT_PAGE}`,
        component: ContractPage
    },
    {
        path: `${APP_PREFIX}/${FLOW_TYPE.HERMES}/${COUNTRY.GERMANY}/${PAGE_NAME.ERROR_PAGE}`,
        component: ErrorPage
    },
    {
        path: `${APP_PREFIX}/${FLOW_TYPE.HERMES}/${COUNTRY.GERMANY}/${PAGE_NAME.DECISION_PAGE}`,
        component: DecisionPage
    },
    {
        path: `${APP_PREFIX}/${FLOW_TYPE.HERMES}/${COUNTRY.GERMANY}/${PAGE_NAME.CYCO_PAGE}`,
        component: CycoPage
    },
    {
        path: `${APP_PREFIX}/${FLOW_TYPE.HERMES}/${COUNTRY.GERMANY}/${PAGE_NAME.DEPRECATED_PAGE}`,
        component: DeprecatedPage
    },

    // Member Flow
    {
        path: `${APP_PREFIX}/${FLOW_TYPE.HERMES}/${COUNTRY.GERMANY}/${PAGE_NAME.REPAYMENT_PAGE}`,
        component: RepaymentPage
    },
    {
        path: `${APP_PREFIX}/${FLOW_TYPE.HERMES}/${COUNTRY.GERMANY}/${PAGE_NAME.PERSONAL_INFO_PAGE}`,
        component: PersonalInfoPage
    },
    {
        path: `${APP_PREFIX}/${FLOW_TYPE.HERMES}/${COUNTRY.GERMANY}/${PAGE_NAME.TERMS_PAGE}`,
        component: TermsPage
    },
];


export default () => {
    return prodRoutes;
};
